import GameSignals from '@/signals/GameSignals'
import { GameStatesEnum } from '@/states/GameStatesEnum'
import { BeforeLoadingState } from '@/states/loadings/BeforeLoadingState'
import { DisplaySplashScreenState } from '@/states/loadings/DisplaySplashScreenState'
import { GetInitResponseState } from '@/states/loadings/GetInitResponseState'
import { InitState } from '@/states/loadings/InitState'
import { LoadingState } from '@/states/loadings/LoadingState'
import { RestoreState } from '@/states/loadings/RestoreState'
import { StartSpinState } from '@/states/reels_spinning/StartSpinState'
import { StopSpinState } from '@/states/reels_spinning/StopSpinState'
import { FinalState } from '@/states/round/FinalState'
import { IdleState } from '@/states/round/IdleState'
import { StartRoundState } from '@/states/round/StartRoundState'
import { StopRoundState } from '@/states/round/StopRoundState'
import { StateMachine } from '@stateMachine/StateMachine'
import StateSignals from '@stateMachine/StateSignals'
import { GetSpinResponseState } from '@/states/reels_spinning/GetSpinResponseState'
import { CascadeState } from '@/states/cascade/CascadeState'
import { GambleState } from '@/states/gamble/GambleState'
import Facade from '@/Facade'
import { GambleFlowManager } from '@dragonframework/modules'

export class GameStateMachine extends StateMachine {
    public init() {
        // game loading states
        this.addState(BeforeLoadingState, GameStatesEnum.BEFORE_LOADING_STATE)
        this.addState(GetInitResponseState, GameStatesEnum.GET_INIT_RESPONSE_STATE)
        this.addState(LoadingState, GameStatesEnum.LOADING_STATE)
        this.addState(InitState, GameStatesEnum.INIT_STATE)
        this.addState(DisplaySplashScreenState, GameStatesEnum.DISPLAY_SPLASH_SCREEN_STATE)

        // round/features logic states
        this.addState(RestoreState, GameStatesEnum.RESTORE_STATE)
        this.addState(IdleState, GameStatesEnum.IDLE_STATE)
        this.addState(StartRoundState, GameStatesEnum.START_ROUND_STATE)
        this.addState(GambleState, GameStatesEnum.GAMBLE_STATE)
        this.addState(CascadeState, GameStatesEnum.CASCADE_STATE)
        this.addState(FinalState, GameStatesEnum.FINAL_STATE)
        this.addState(StopRoundState, GameStatesEnum.STOP_ROUND_STATE)

        // reels spinning states
        this.addState(StartSpinState, GameStatesEnum.START_SPIN_STATE)
        this.addState(GetSpinResponseState, GameStatesEnum.GET_SPIN_RESPONSE_STATE)
        this.addState(StopSpinState, GameStatesEnum.STOP_SPIN_STATE)

        GameSignals.gamePause.connect(() => {
            if (GambleFlowManager.isActive()) {
                if (Facade.currentState !== GameStatesEnum.GAMBLE_STATE) {
                    this.setState(GameStatesEnum.GAMBLE_STATE)
                }
                return
            }

            this.setState(GameStatesEnum.IDLE_STATE)
        })
    }

    public applyState(id: string) {
        console.log('STATE CHANGED:', id)
        StateSignals.stateChanged.emit(id)

        super.applyState(id)
    }
}
